module.exports = __webpack_public_path__ + "static/media/c3bannerModul3_small.c50e64d4.jpg";